import axios from 'axios'

// Sign Up method
export const signUp = payload => {
    return new Promise(((resolve, reject) => {
        axios.post('user/create', payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}

// Interest Form submission method
export const submitInterestForm = (formData) => {
    return new Promise(((resolve, reject) => {
        axios.post('interestform/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error))
    }))
}